// @flow

import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { reduxForm } from 'redux-form';
import config from '../../../config';
import ValidationService from '../../../lib/validation';
import { isLoadingSelector } from '../../../modules/LoadingStatus/reducer';
import { triggerEmailValidation } from '../../../modules/SignUp/actions';
import { createAccountFormValuesSelector } from '../../../modules/SignUp/Login/reducer';
import CreateAccount from './CreateAccount';

const validate = values => {
  return {
    email: ValidationService.validateEmail(values.email),
    password: ValidationService.validatePassword(values.password),
  };
};

const mapStateToProps = state => ({
  initialValues: createAccountFormValuesSelector(state),
  isLoading: isLoadingSelector(state, 'createAccount'),
  showAlreadyHaveAccount: config.canAddLines,
});

const mapDispatchToProps = dispatch => ({
  onSubmit: values => {
    dispatch(triggerEmailValidation(values));
  },
});

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), reduxForm({ form: 'createAccount', validate }));

export default enhance(CreateAccount);
